import React, { useState, useEffect } from "react";
import { themes } from "services/constants";
import { showToast } from "services/utils/Status";
import { CustomButtonWithOutLoader } from "components/CustomComponents/CustomButton";
import * as Mui from "@mui/material";
import { useSelector } from "react-redux";
import { useFetch } from "services/hooks/useFetch";
import { customAPI } from "services/utils/CustomAPI";
import { rowEndStyle } from "services/constants/Styles";

export const Features = ({ modifiedData, setModifiedData }) => {
  const [tableHeight, setTableHeight] = useState(window.innerHeight * 0.7);
  const [firstTimeTrigger, setFristTimeTrigger] = useState(true);
  const [subModuleDetails, setSubmoduleDetails] = useState([]);
  const { domain } = useSelector((state) => state.tokenReducer);
  const {
    result: SubModules,
    loading: submoduleLoading,
    setLoad,
  } = useFetch(`${domain}modules/list/`);

  useEffect(() => {
    const updateHeight = () => {
      setTableHeight(window.innerHeight * 0.7);
    };

    window.addEventListener("resize", updateHeight);

    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  useEffect(() => {
    const updateModuleAndProducts = () => {
      const filterData = SubModules.filter(
        (item) => item.name !== "Product Control"
      );
      setSubmoduleDetails(filterData);
    };
    if (!submoduleLoading && firstTimeTrigger) {
      setFristTimeTrigger(false);
      updateModuleAndProducts();
    }
  }, [SubModules, firstTimeTrigger, submoduleLoading]);

  const updateFeatureCheckBoxDetails = (value, productName) => {
    let updatedProductValue = subModuleDetails.map((sub_modules) => {
      if (sub_modules.name !== productName) return sub_modules;
      return {
        ...sub_modules,
        is_active: value,
      };
    });
    setSubmoduleDetails(updatedProductValue);
    setModifiedData(true);
  };

  const updateProductAndSubModule = async () => {
    const activeModuleIds = subModuleDetails
      .filter((item) => item.is_active)
      .map((item) => item.id);
    const response = await customAPI(`${domain}module-activation/`, "POST", {
      active_module_ids: activeModuleIds,
    });
    if (response.ok) {
      showToast("success", "Features are updated successfully");
      setModifiedData(false);
    }
  };

  return (
    <React.Fragment>
      <Mui.Grid container sx={{ padding: 2 }}>
        <Mui.Grid xs={2}></Mui.Grid>
        <Mui.Grid xs={8} sx={{ minHeight: tableHeight }} component={Mui.Paper}>
          <Mui.Grid
            container
            sx={{ backgroundColor: themes.formBackground, padding: 1 }}
          >
            <Mui.Typography
              sx={{
                fontWeight: "bold",
                fontSize: 18,
                textAlign: "center",
                width: "100%",
              }}
            >
              Feature
            </Mui.Typography>
          </Mui.Grid>
          <Mui.Grid container sx={{ width: "100%" }}>
            {subModuleDetails?.map((data) => (
              <Mui.Grid container>
                <Mui.Grid xs={5}></Mui.Grid>
                <Mui.Grid container xs={3}>
                  <Mui.Grid xs={2}>
                    <Mui.Checkbox
                      checked={!!data?.is_active}
                      onChange={(event) => {
                        updateFeatureCheckBoxDetails(
                          event.target.checked,
                          data?.name
                        );
                      }}
                      size="medium"
                    />
                  </Mui.Grid>
                  <Mui.Grid xs={10}>
                    <Mui.Typography
                      sx={{
                        paddingTop: 1,
                        color: themes.headLine,
                        fontWeight: "bold",
                      }}
                    >
                      {data?.name}
                    </Mui.Typography>
                  </Mui.Grid>
                </Mui.Grid>
                <Mui.Grid xs={4}></Mui.Grid>
              </Mui.Grid>
            ))}
          </Mui.Grid>
        </Mui.Grid>
        <Mui.Grid xs={2}></Mui.Grid>
      </Mui.Grid>
      <Mui.Grid
        container
        sx={{
          ...rowEndStyle,
          paddingRight: 4,
          paddingTop: 2,
          paddingBottom: 2,
        }}
      >
        <CustomButtonWithOutLoader
          actionFuntion={() => {
            setLoad(true);
            setFristTimeTrigger(true);
            setModifiedData(false);
          }}
          actionName="Reset"
          typeName="button"
          disableAction={!modifiedData}
        />{" "}
        &nbsp;
        <CustomButtonWithOutLoader
          actionFuntion={() => {
            updateProductAndSubModule();
          }}
          actionName="Save"
          typeName="button"
          disableAction={!modifiedData}
        />
      </Mui.Grid>
    </React.Fragment>
  );
};
